// Get the modal
if(document.getElementById("myModal-ithelps")) {
  var modal = document.getElementById("myModal-ithelps");
  var modal2 = document.getElementById("myModal-ithelps-2");

  // Get the button that opens the modal
  var btn = document.getElementById("myBtn-ithelps");
  var btn2 = document.getElementById("myBtn-ithelps-2");

  // Get the <span> element that closes the modal
  var span = document.querySelectorAll(".close");

  // When the user clicks on the button, open the modal
  if (btn) {
    btn.onclick = function() {
      modal.style.display = "block";
    }
  }

  if (btn2 && modal2) {
    btn2.onclick = function() {
      modal2.style.display = "block";
      modal2.style.zIndex = "2";
    }
  }

  // When the user clicks on <span> (x), close the modal
  // span.onclick = function() {
  //   modal.style.display = "none";
  // }

  span.forEach(el => {
    el.addEventListener("click", () => {
      modal.style.display = "none"
      if (modal2) {
        modal2.style.display = "none"
      }
    })
  })

  // When the user clicks anywhere outside of the modal, close it
  window.onclick = function(event) {
    if (event.target == modal) {
      modal.style.display = "none";
      if (modal2) {
        modal2.style.display = "none";
      }
    }
  }
}

// Get the contact form modal
if(document.getElementById("myModal-ithelps-contact")) {
  var modalContact = document.getElementById("myModal-ithelps-contact");  

  // Get the button that opens the modal
  var btnContact = document.getElementById("myBtn-ithelps-contact");

  // Get the <span> element that closes the modal
  var span = document.getElementsByClassName("close-contact")[0];

  // When the user clicks on the button, open the modal
  btnContact.onclick = function() {
    modalContact.style.display = "block";
  }

  // When the user clicks on <span> (x), close the modal
  span.onclick = function() {
    modalContact.style.display = "none";
  }

  // When the user clicks anywhere outside of the modal, close it
  window.onclick = function(event) {
    if (event.target == modal) {
      modalContact.style.display = "none";
    }
  }
}

if(window.location.href.includes("contact_posted=true")) {
  if(document.getElementById("myModal-ithelps-contact")) {
    var modalContact = document.getElementById("myModal-ithelps-contact");  
    modalContact.style.display = "block";
  }
}


/*
  Swatch / size-availability / image-swap handlers are now
  registered via event delegation at the bottom of this file
  so they work for both initial AND AJAX-loaded product cards.
*/


/* Customize look section */
window.addEventListener("load", (event) => {
  if(document.querySelector(".mit-productitem-img-secondary")) {
    document.querySelectorAll(".mit-productitem-img-secondary").forEach(secondary => {

      secondary.addEventListener("mouseover", () => {
          secondary.parentElement.querySelector("img").style.opacity = "0"
      })
  
          secondary.addEventListener("mouseleave", () => {
          secondary.parentElement.querySelector("img").style.opacity = "1"
      })
    
    })
  }

  /* Menu */
  /*if(window.location.href.includes("/en")) {
    document.querySelectorAll(".header__links-list > li")[0].style.display = "none";
    document.querySelectorAll(".header__links-list > li")[2].style.display = "none";

    document.querySelectorAll(".drawer-menu__primary-links > li")[0].style.display = "none";
    document.querySelectorAll(".drawer-menu__primary-links > li")[2].style.display = "none";
    
  } else {
    document.querySelectorAll(".header__links-list > li")[1].style.display = "none";
    document.querySelectorAll(".header__links-list > li")[3].style.display = "none";

    document.querySelectorAll(".drawer-menu__primary-links > li")[1].style.display = "none";
    document.querySelectorAll(".drawer-menu__primary-links > li")[3].style.display = "none";
  }*/

});


// Size availability: initial hide (CSS now handles this via .size-availability__color { display:none })
document.addEventListener('DOMContentLoaded', function() {
  initSizeAvailability();
});

function initSizeAvailability() { 
  // Initially hide all size availability elements
  document.querySelectorAll('.product-item__size-availability').forEach(container => {
    container.style.display = 'none';
  });
  
  document.querySelectorAll('.size-availability__color').forEach(el => {
    el.style.display = 'none';
  });
}

function handleSwatchClick(e) {
  e.preventDefault();
  const productId = this.getAttribute('data-prod-id');
  const colorValue = this.getAttribute('data-option-value');
  
  if (!colorValue) {
    return;
  }
  
  // Get the availability container
  const availabilityContainer = document.querySelector(`.product-item__size-availability[data-product-id="${productId}"]`);
  
  if (availabilityContainer) {
    // First check if the container has content
    if (availabilityContainer.children.length === 0) {
      return;
    }
    
    // Make all swatches look inactive
    const allSwatches = document.querySelectorAll(`[data-prod-id="${productId}"].product-swatches-options__item--swatch`);
    allSwatches.forEach(swatch => {
      swatch.classList.remove('active-swatch');
    });
    
    // Toggle the container visibility
    const isCurrentlyVisible = availabilityContainer.classList.contains('is-visible');
    
    if (isCurrentlyVisible && availabilityContainer.getAttribute('data-current-color') === colorValue) {
      // If clicking the same color again, hide it
      availabilityContainer.classList.remove('is-visible');
      availabilityContainer.style.display = 'none';
      return;
    }
    
    // Mark this swatch as active
    this.classList.add('active-swatch');
    
    // Position the container as a relative element below the swatches section
    positionAvailabilityContainerRelative(availabilityContainer, this);
    
    // Show the container
    availabilityContainer.classList.add('is-visible');
    availabilityContainer.style.display = 'flex';
    availabilityContainer.setAttribute('data-current-color', colorValue);
    
    // Hide all color sections
    availabilityContainer.querySelectorAll('.size-availability__color').forEach(el => {
      el.style.display = 'none';
    });
    
    // Find color section using multiple approaches for reliability
    let colorSection = findColorSection(availabilityContainer, colorValue);
    
    if (colorSection) {
      colorSection.style.display = 'block';
      
      // Log all sizes for this color
      const allSizes = colorSection.querySelectorAll('.size-availability__item');
      
      for (const sizeItem of allSizes) {
        const size = sizeItem.textContent.trim();
        const variantId = sizeItem.getAttribute('data-variant-id');
        const inventory = sizeItem.getAttribute('data-inventory');
        const isAvailable = sizeItem.classList.contains('available');
      }
    } else {
      // As a fallback, show the first color section if no matching one is found
      const firstColorSection = availabilityContainer.querySelector('.size-availability__color');
      if (firstColorSection) {
        firstColorSection.style.display = 'block';
      }
    }
  }
}

// Helper function to find color section with different approaches
function findColorSection(container, colorValue) {
  // 1. Try exact match first
  let colorSection = container.querySelector(`.size-availability__color[data-color="${colorValue}"]`);
  
  // 2. If that fails, try with encoding
  if (!colorSection) {
    const encodedColor = encodeURIComponent(colorValue);
    colorSection = container.querySelector(`.size-availability__color[data-color="${encodedColor}"]`);
  }
  
  // 3. Try a case-insensitive match as a fallback
  if (!colorSection) {
    const allColorSections = container.querySelectorAll('.size-availability__color');
    for (const section of allColorSections) {
      const sectionColor = section.getAttribute('data-color');
      if (sectionColor && sectionColor.toLowerCase() === colorValue.toLowerCase()) {
        colorSection = section;
        break;
      }
    }
  }
  
  // 4. Special check for colors with slashes or special characters
  if (!colorSection) {
    const normalizedColor = colorValue.replace(/[^a-zA-Z0-9]/g, '').toLowerCase();
    const allColorSections = container.querySelectorAll('.size-availability__color');
    
    for (const section of allColorSections) {
      const sectionColor = section.getAttribute('data-color');
      if (sectionColor) {
        const normalizedSectionColor = sectionColor.replace(/[^a-zA-Z0-9]/g, '').toLowerCase();
        if (normalizedColor === normalizedSectionColor) {
          colorSection = section;
          break;
        }
      }
    }
  }
  
  return colorSection;
}

// Position function for overlaying on the image
function positionAvailabilityContainerRelative(container, swatch) {
  // Find the product media element
  const productItem = swatch.closest('.product-item');
  const productMedia = productItem.querySelector('.product-item__media');
  
  if (productMedia) {
    // Remove the container from its current position if needed
    if (container.parentNode) {
      container.parentNode.removeChild(container);
    }
    
    // Add the container to the product media element
    productMedia.appendChild(container);
  }
}

function handleSwatchHover(e) {
  const productId = this.getAttribute('data-prod-id');
  const colorValue = this.getAttribute('data-option-value');
  
  if (!colorValue) {
    return;
  }
  
  // Show the size availability on hover
  const availabilityContainer = document.querySelector(`.product-item__size-availability[data-product-id="${productId}"]`);
  
  if (availabilityContainer) {
    // First check if the container has content
    if (availabilityContainer.children.length === 0) {
      return;
    }
    
    // Position the container near the swatch
    positionAvailabilityContainer(availabilityContainer, this);
    
    // Show the container
    availabilityContainer.style.display = 'block';
    
    // Hide all color sections
    availabilityContainer.querySelectorAll('.size-availability__color').forEach(el => {
      el.style.display = 'none';
    });
    
    // Find color section using multiple approaches for reliability
    let colorSection = null;
    
    // 1. Try exact match first
    colorSection = availabilityContainer.querySelector(`.size-availability__color[data-color="${colorValue}"]`);
    
    // 2. If that fails, try with encoding
    if (!colorSection) {
      const encodedColor = encodeURIComponent(colorValue);
      colorSection = availabilityContainer.querySelector(`.size-availability__color[data-color="${encodedColor}"]`);
    }
    
    // 3. Try a case-insensitive match as a fallback
    if (!colorSection) {
      const allColorSections = availabilityContainer.querySelectorAll('.size-availability__color');
      for (const section of allColorSections) {
        const sectionColor = section.getAttribute('data-color');
        if (sectionColor && sectionColor.toLowerCase() === colorValue.toLowerCase()) {
          colorSection = section;
          break;
        }
      }
    }
    
    // 4. Special check for colors with slashes or special characters
    if (!colorSection) {
      const normalizedColor = colorValue.replace(/[^a-zA-Z0-9]/g, '').toLowerCase();
      const allColorSections = availabilityContainer.querySelectorAll('.size-availability__color');
      
      for (const section of allColorSections) {
        const sectionColor = section.getAttribute('data-color');
        if (sectionColor) {
          const normalizedSectionColor = sectionColor.replace(/[^a-zA-Z0-9]/g, '').toLowerCase();
          if (normalizedColor === normalizedSectionColor) {
            colorSection = section;
            break;
          }
        }
      }
    }
    
    if (colorSection) {
      colorSection.style.display = 'block';
      
      // Logging specific info about the 0/XS size if present
      const specialSize = '0/XS';
      const specialSizeElement = colorSection.querySelector(`.size-availability__item[data-size="${specialSize}"]`);
      
      if (specialSizeElement) {
        const variantId = specialSizeElement.getAttribute('data-variant-id');
        const inventory = specialSizeElement.getAttribute('data-inventory');
        const isAvailable = specialSizeElement.classList.contains('available');
      }
      
      // Log all sizes for this color
      const allSizes = colorSection.querySelectorAll('.size-availability__item');
      
      for (const sizeItem of allSizes) {
        const size = sizeItem.textContent.trim();
        const variantId = sizeItem.getAttribute('data-variant-id');
        const inventory = sizeItem.getAttribute('data-inventory');
        const isAvailable = sizeItem.classList.contains('available');
      }
    } else {
      // As a fallback, show the first color section if no matching one is found
      const firstColorSection = availabilityContainer.querySelector('.size-availability__color');
      if (firstColorSection) {
        firstColorSection.style.display = 'block';
      }
    }
  }
}

function handleSwatchLeave(e) {
  // Use a timeout to prevent flickering when moving between swatches
  setTimeout(() => {
    const productId = this.getAttribute('data-prod-id');
    const availabilityContainer = document.querySelector(`.product-item__size-availability[data-product-id="${productId}"]`);
    
    if (availabilityContainer && !availabilityContainer.matches(':hover')) {
      availabilityContainer.style.display = 'none';
    }
  }, 200);
}

function positionAvailabilityContainer(container, swatch) {
  const swatchRect = swatch.getBoundingClientRect();
  const containerParent = swatch.closest('.product-item');
  
  if (containerParent) {
    // Append the container to the product item if it's not already there
    if (!containerParent.contains(container)) {
      containerParent.appendChild(container);
    }
    
    // Check if container should be positioned to avoid going off-screen
    const viewportWidth = window.innerWidth;
    
    // Position the container below and aligned with the swatch
    const parentRect = containerParent.getBoundingClientRect();
    const topPosition = swatchRect.bottom - parentRect.top + 5;
    let leftPosition = swatchRect.left - parentRect.left;
    
    // Adjust horizontal position if it would go off-screen
    const containerWidth = 200; // Width from CSS
    if (swatchRect.left + containerWidth > viewportWidth) {
      leftPosition = Math.max(0, viewportWidth - containerWidth - parentRect.left - 10);
    }
    
    // Set the position
    container.style.top = `${topPosition}px`;
    container.style.left = `${leftPosition}px`;
    
    // Make sure the container has its display set properly
    if (container.style.display !== 'block') {
      container.style.display = 'block';
    }
    
  }
}

document.addEventListener("DOMContentLoaded", function () {
  setTimeout(function() {
    // Get the required elements
  const submitButtonGroup = document.querySelector(".product-form__controls-group--submit");
  const wishlistIcon = document.querySelector(".wishlist-hero-product-app-block");
  const productVariants = document.querySelector(".product-form__variants");
  
    if (submitButtonGroup && wishlistIcon && productVariants) {
        // Get the parent of the wishlist icon
        const wishlistParent = wishlistIcon.parentElement;
        
        // Create a new wrapper div
        const wrapperDiv = document.createElement("div");
        wrapperDiv.style.display = "flex";
        wrapperDiv.style.alignItems = "center";
        wrapperDiv.style.gap = "10px";
        
        // Create styled divs for layout
        const submitWrapper = document.createElement("div");
        submitWrapper.style.flex = "3"; // 75%
        submitWrapper.appendChild(submitButtonGroup);
        
        const wishlistWrapper = document.createElement("div");
        wishlistWrapper.style.flex = "0"; // 25%
        
        // Remove text from wishlist button, keeping only the SVG
        const wishlistButton = wishlistParent.querySelector("button");
        if (wishlistButton) {
            const wishlistSVG = wishlistButton.querySelector("svg");
            wishlistButton.innerHTML = ""; // Clear all content
            if (wishlistSVG) {
                wishlistButton.appendChild(wishlistSVG); // Re-add SVG only
            }
        }
        
        wishlistWrapper.appendChild(wishlistParent);
        
        // Append both elements to the wrapper
        wrapperDiv.appendChild(submitWrapper);
        wrapperDiv.appendChild(wishlistWrapper);
        
        // Insert the wrapper after product-form__variants
        productVariants.insertAdjacentElement("afterend", wrapperDiv);

      wishlistIcon.style.opacity = "1";
    }
  }, 1000)
  
});


function updateProductLinks(productContainer, variantUrl) {
  // Update main product link
  const productLink = productContainer.querySelector('[data-product-link]');
  if (productLink) {
    productLink.setAttribute('href', variantUrl);
  }
  
  // Update product title link
  const titleLink = productContainer.querySelector('[data-product-title-link]');
  if (titleLink) {
    titleLink.setAttribute('href', variantUrl);
  }
  
  // Update quick view buttons if they exist
  const quickViewLinks = productContainer.querySelectorAll('[data-quick-view-link], [data-quick-view-button], [data-quick-view-beneath]');
  quickViewLinks.forEach(link => {
    link.setAttribute('href', variantUrl);
  });
}

function highlightSelectedSwatch(productContainer, selectedSwatch) {
  // Remove highlight from all swatches in this product
  const allSwatches = productContainer.querySelectorAll('.product-swatches-options__item--swatch');
  allSwatches.forEach(swatch => {
    swatch.classList.remove('selected');
    // Optional: Remove any custom styling you might add
    swatch.style.border = '';
  });
  
  // Add highlight to selected swatch
  selectedSwatch.classList.add('selected');
  // Optional: Add custom styling
  
}

// =================================================================
// EVENT DELEGATION for swatch / size-availability / image-swap
// Uses document-level listeners so dynamically loaded product cards
// (via Ajaxinate "Load More") work without re-binding.
// =================================================================
(function () {

  function getVariantImageData(productContainer, productId, colorValue) {
    const imageItems = productContainer.querySelectorAll('.mit-product-image-data [data-product-id="' + productId + '"]');

    for (const item of imageItems) {
      // Spans mit data-filter-only (Produkte ohne Size-Option) sind nur fuer den Farb-Filter-Bildwechsel gedacht
      if (item.hasAttribute('data-filter-only')) continue;
      if (item.getAttribute('data-option-color') === colorValue) {
        return item;
      }
    }

    return null;
  }

  // --- 1. Swatch click: image swap, size overlay and URL update ---
  document.addEventListener('click', function (e) {
    var swatch = e.target.closest('.product-swatches-options__item--swatch');
    if (!swatch) return;

    var productId = swatch.getAttribute('data-prod-id');
    var colorValue = swatch.getAttribute('data-option-value');
    if (!productId || !colorValue) return;

    // WICHTIG: .product-item als Container nehmen, NICHT '[data-prod-id]'.
    // Das Swatch-<li> traegt selbst data-prod-id, sonst liefert closest() das
    // <li> zurueck und die Bild-/Link-Suche laeuft ins Leere (Bild wechselt nicht).
    var productContainer = swatch.closest('.product-item') || document.querySelector('.product-item[data-prod-id="' + productId + '"]');
    if (!productContainer) return;

    var imageData = getVariantImageData(productContainer, productId, colorValue);

    if (imageData) {
      var primaryEl = productContainer.querySelector('.product-item__image--one > img, .product-item__image > img');
      var secondaryEl = productContainer.querySelector('.product-item__image--two > img');
      var primarySrc = imageData.getAttribute('data-primary-src');
      var secondarySrc = imageData.getAttribute('data-secondary-src');

      if (primaryEl && primarySrc) {
        primaryEl.src = primarySrc;
        primaryEl.removeAttribute('srcset');
      }
      if (secondaryEl && secondarySrc) {
        secondaryEl.src = secondarySrc;
        secondaryEl.removeAttribute('srcset');
      }
    }

    handleSwatchClick.call(swatch, e);

    // Farbname-Label unter den Swatches aktualisieren
    var colorLabelEl = productContainer.querySelector('[data-selected-color]');
    if (colorLabelEl) {
      var colorPrefix = colorLabelEl.getAttribute('data-color-label') || '';
      colorLabelEl.textContent = colorPrefix ? (colorPrefix + ': ' + colorValue) : colorValue;
    }

    var variantUrl = swatch.getAttribute('data-variant-url');
    if (variantUrl) {
      updateProductLinks(productContainer, variantUrl);
      highlightSelectedSwatch(productContainer, swatch);
    }
  });

  // --- 2. Swatch hover: Variantenbild vorab laden ---
  // Warmt den Browser-Cache, sobald der Nutzer ueber einen Swatch faehrt.
  // Dadurch ist das Bild beim eigentlichen Klick i. d. R. schon geladen und
  // der Wechsel wirkt verzoegerungsfrei (kein Netzwerk-Delay mehr).
  var prefetchedSwatchSrc = {};

  function prefetchSwatchImage(swatch) {
    var productId = swatch.getAttribute('data-prod-id');
    var colorValue = swatch.getAttribute('data-option-value');
    if (!productId || !colorValue) return;

    var productContainer = swatch.closest('.product-item');
    if (!productContainer) return;

    var imageData = getVariantImageData(productContainer, productId, colorValue);
    if (!imageData) return;

    ['data-primary-src', 'data-secondary-src'].forEach(function (attr) {
      var src = imageData.getAttribute(attr);
      if (src && !prefetchedSwatchSrc[src]) {
        prefetchedSwatchSrc[src] = true;
        var img = new Image();
        img.decoding = 'async';
        img.src = src; // laedt im Hintergrund in den Cache
      }
    });
  }

  document.addEventListener('pointerover', function (e) {
    var swatch = e.target.closest('.product-swatches-options__item--swatch');
    if (swatch) prefetchSwatchImage(swatch);
  });

  // --- 4. "Show more swatches" link ---
  document.addEventListener('click', function (e) {
    var showMore = e.target.closest('.mit-show-hidden-swatches');
    if (!showMore) return;
    e.preventDefault();

    var productContainer = showMore.closest('.product-item');
    if (productContainer) {
      productContainer.querySelectorAll('[data-visible="hidden"]').forEach(function (sw) {
        sw.setAttribute('data-visible', 'visible');
        sw.style.display = 'inline-block';
      });
    }
    showMore.style.display = 'none';
  });

  // --- 5. MutationObserver: re-init size-availability state for AJAX-loaded products ---
  function observeCollectionGrid() {
    var grid = document.querySelector('.collection__infinite-container');
    if (!grid) return;

    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        if (mutations[i].addedNodes.length) {
          initSizeAvailability();
          return;
        }
      }
    }).observe(grid, { childList: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeCollectionGrid);
  } else {
    observeCollectionGrid();
  }

})();

// =================================================================
// FARB-FILTER -> KACHELBILD
// Ist in der Kollektion ein Farb-/Farbgruppen-Filter aktiv, zeigt jede Produktkachel
// das Bild der passenden Farbvariante (statt des Default-Bildes). Nutzt die
// vorhandenen .mit-product-image-data-Spans aus snippets/product-item.liquid.
// Gruppe -> Roh-Farben kommt aus <script data-farbgruppen-map> (Metaobjekt
// cockpit_filter_gruppe); fehlt die Map/der Eintrag, gilt der Filterwert selbst als
// Farbname. Ohne Treffer bleibt das Default-Bild. Ohne aktiven Filter passiert nichts.
// Der Theme-AJAX-Rerender ersetzt den Inhalt von #root[data-partial] -> wir beobachten
// diesen persistenten Knoten (Filter-Rerender + Infinite-Scroll) und popstate.
// =================================================================
(function () {
  var FILTER_PARAM_RE = /^filter\.(?:p\.m\.[^.]+\.(?:farbgruppe|farbgruppen|farbe|farben|color|colour)|v\.option\.(?:color|colour|farbe))$/i;
  var SIG_ATTR = 'data-fs-filter-sig';
  var timer = null;
  var observedRoot = null;
  var observer = null;

  function norm(s) {
    var str = String(s == null ? '' : s);
    try { str = str.normalize('NFD').replace(/[̀-ͯ]/g, ''); } catch (e) { /* ignore */ }
    return str.trim().toLowerCase();
  }

  function readGroupMap() {
    var map = {};
    try {
      var el = document.querySelector('script[data-farbgruppen-map]');
      if (!el) return map;
      var raw = JSON.parse(el.textContent || '{}');
      Object.keys(raw || {}).forEach(function (group) {
        var colors = [];
        [].concat(raw[group] || []).forEach(function (entry) {
          String(entry == null ? '' : entry).split(/[,;\n]/).forEach(function (c) {
            var n = norm(c);
            if (n) colors.push(n);
          });
        });
        map[norm(group)] = colors;
      });
    } catch (e) { /* ungueltige Map -> Identity-Fallback */ }
    return map;
  }

  // Liefert { sig, colors:Set-aehnliches Objekt } oder null (kein aktiver Farb-Filter)
  function getActiveColorFilter() {
    var params;
    try { params = new URLSearchParams(window.location.search); } catch (e) { return null; }

    var values = [];
    params.forEach(function (value, key) {
      if (FILTER_PARAM_RE.test(key) && norm(value)) values.push(value);
    });
    if (!values.length) return null;

    var groupMap = readGroupMap();
    var colors = {};
    values.forEach(function (value) {
      var key = norm(value);
      colors[key] = true; // Identity-Fallback (Einzelfarbe / Gruppenname = Farbname)
      (groupMap[key] || []).forEach(function (c) { colors[c] = true; });
    });

    return { sig: values.map(norm).sort().join('|'), colors: colors };
  }

  // Link-Elemente der Kachel (Bild-Link, Titel-Link, Quick-View), die beim Farbwechsel mitwandern muessen
  var LINK_SEL = '[data-product-link], [data-product-title-link], [data-quick-view-link], [data-quick-view-button], [data-quick-view-beneath]';

  // Label ("Farbe: ..."), Links und Swatch-Markierung wieder auf den Default (erste Variante) zuruecksetzen
  function restoreCardMeta(card) {
    var labelEl = card.querySelector('[data-selected-color]');
    if (labelEl && labelEl.hasAttribute('data-fs-orig-label')) {
      labelEl.textContent = labelEl.getAttribute('data-fs-orig-label');
      labelEl.removeAttribute('data-fs-orig-label');
    }
    var links = card.querySelectorAll('[data-fs-orig-href]');
    for (var i = 0; i < links.length; i++) {
      links[i].setAttribute('href', links[i].getAttribute('data-fs-orig-href'));
      links[i].removeAttribute('data-fs-orig-href');
    }
    // Default-Zustand hat keine markierte Swatch (auch eine nach dem Filter geklickte Wahl faellt zurueck)
    var marked = card.querySelectorAll('.product-swatches-options__item--swatch.selected');
    for (var j = 0; j < marked.length; j++) {
      marked[j].classList.remove('selected');
      marked[j].removeAttribute('data-fs-selected');
    }
  }

  // Swatch der Kachel zur Farbe (exakter Wert wie im Span/Swatch-<li>) finden
  function findSwatch(card, colorValue) {
    var sw = card.querySelectorAll('.product-swatches-options__item--swatch');
    for (var i = 0; i < sw.length; i++) {
      if (sw[i].getAttribute('data-option-value') === colorValue) return sw[i];
    }
    return null;
  }

  // Label, Links und Swatch auf die gefilterte Farbe stellen -> Bild, Label und Klickziel stimmen ueberein
  function syncCardMeta(card, swatch, colorValue) {
    var labelEl = card.querySelector('[data-selected-color]');
    if (labelEl) {
      if (!labelEl.hasAttribute('data-fs-orig-label')) labelEl.setAttribute('data-fs-orig-label', labelEl.textContent);
      var prefix = labelEl.getAttribute('data-color-label') || '';
      labelEl.textContent = prefix ? (prefix + ': ' + colorValue) : colorValue;
    }
    var variantUrl = swatch.getAttribute('data-variant-url');
    if (variantUrl) {
      var links = card.querySelectorAll(LINK_SEL);
      for (var i = 0; i < links.length; i++) {
        if (!links[i].hasAttribute('data-fs-orig-href')) links[i].setAttribute('data-fs-orig-href', links[i].getAttribute('href') || '');
        links[i].setAttribute('href', variantUrl);
      }
    }
    if (!swatch.classList.contains('selected')) {
      var marked = card.querySelectorAll('.product-swatches-options__item--swatch.selected');
      for (var j = 0; j < marked.length; j++) marked[j].classList.remove('selected');
      swatch.classList.add('selected');
      swatch.setAttribute('data-fs-selected', '');
    }
  }

  function restoreCard(card) {
    restoreCardMeta(card);
    var imgs = card.querySelectorAll('img[data-fs-orig-src]');
    for (var i = 0; i < imgs.length; i++) {
      var img = imgs[i];
      img.setAttribute('src', img.getAttribute('data-fs-orig-src'));
      var origSrcset = img.getAttribute('data-fs-orig-srcset');
      if (origSrcset) img.setAttribute('srcset', origSrcset);
      img.removeAttribute('data-fs-orig-src');
      img.removeAttribute('data-fs-orig-srcset');
    }
  }

  function swapImg(img, src) {
    if (!img || !src) return;
    if (!img.hasAttribute('data-fs-orig-src')) {
      img.setAttribute('data-fs-orig-src', img.getAttribute('src') || '');
      img.setAttribute('data-fs-orig-srcset', img.getAttribute('srcset') || '');
    }
    img.src = src;
    img.removeAttribute('srcset'); // sonst gewinnt das srcset der Responsive-Image-Ausgabe
  }

  function applyToCard(card, filter) {
    var currentSig = card.getAttribute(SIG_ATTR) || '';
    var wantedSig = filter ? filter.sig : '';
    // schon verarbeitet (Swatch-Wahl des Nutzers bleibt erhalten) - ausser das Bild wurde zwischenzeitlich
    // vom Theme zurueckgesetzt (kein data-fs-orig-src mehr): dann erneut anwenden
    if (currentSig === wantedSig && (!filter || card.querySelector('img[data-fs-orig-src]') || !card.querySelector('.mit-product-image-data [data-option-color]'))) return;

    if (currentSig) restoreCard(card);
    if (!filter) {
      card.removeAttribute(SIG_ATTR);
      return;
    }
    card.setAttribute(SIG_ATTR, wantedSig);

    var spans = card.querySelectorAll('.mit-product-image-data [data-option-color]');
    var match = null;
    for (var i = 0; i < spans.length; i++) {
      if (filter.colors[norm(spans[i].getAttribute('data-option-color'))] && spans[i].getAttribute('data-primary-src')) {
        match = spans[i];
        break;
      }
    }
    if (!match) return; // keine Daten / keine passende Farbe -> Default-Bild

    // Bild NUR tauschen, wenn auch Label + Klickziel auf dieselbe Farbe gestellt werden koennen
    // (Swatch mit Variant-URL vorhanden). Sonst zeigt die Kachel Farbe A, das Label/der Link aber Farbe B.
    var colorValue = match.getAttribute('data-option-color');
    var swatch = findSwatch(card, colorValue);
    if (!swatch || !swatch.getAttribute('data-variant-url')) return;

    swapImg(card.querySelector('.product-item__image--one > img, .product-item__image > img'), match.getAttribute('data-primary-src'));
    swapImg(card.querySelector('.product-item__image--two > img'), match.getAttribute('data-secondary-src'));
    syncCardMeta(card, swatch, colorValue);
  }

  function applyColorFilterImages() {
    try {
      var filter = getActiveColorFilter();
      var cards = document.querySelectorAll('.product-item[data-prod-id]');
      for (var i = 0; i < cards.length; i++) applyToCard(cards[i], filter);
    } catch (e) { /* nie die Seite brechen */ }
  }

  // Mehrfach-Durchlauf (idempotent): Der Theme-Rerender setzt innerHTML, pusht die URL
  // und initialisiert die Kacheln in getrennten Schritten. Ein einzelner Lauf kann daher
  // vor dem endgueltigen Zustand laufen. Jeder Lauf liest die URL frisch aus.
  var DELAYS = [0, 80, 350, 900];
  var timers = [];

  function schedule() {
    if (timer) { clearTimeout(timer); timer = null; }
    while (timers.length) clearTimeout(timers.pop());
    DELAYS.forEach(function (ms) {
      timers.push(setTimeout(function () { observeRoot(); applyColorFilterImages(); }, ms));
    });
  }

  function observeRoot() {
    var root = document.querySelector('#root[data-partial], [data-partial]');
    if (!root || root === observedRoot) return;
    if (observer) observer.disconnect();
    observedRoot = root;
    observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        if (mutations[i].addedNodes.length) { schedule(); return; }
      }
    });
    observer.observe(root, { childList: true, subtree: true });
  }

  // URL-Wechsel (pushState/replaceState des Theme-Filters) sofort mitbekommen
  ['pushState', 'replaceState'].forEach(function (fn) {
    var orig = window.history[fn];
    if (typeof orig !== 'function') return;
    window.history[fn] = function () {
      var ret = orig.apply(this, arguments);
      schedule();
      return ret;
    };
  });

  // Klick/Aenderung an Filtern (Farbe waehlen/entfernen) -> neu auswerten
  var FILTER_UI = 'form, [data-filter-bar], [data-filter-drawer], [data-remove-filter], a[href*="filter."], [data-clear-all]';
  ['click', 'change'].forEach(function (evt) {
    document.addEventListener(evt, function (e) {
      var t = e.target;
      if (t && t.closest && t.closest(FILTER_UI)) schedule();
    }, true);
  });

  function init() {
    observeRoot();
    applyColorFilterImages();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  window.addEventListener('load', function () { observeRoot(); applyColorFilterImages(); });
  window.addEventListener('popstate', function () { schedule(); setTimeout(schedule, 250); });
  window.addEventListener('pageshow', schedule);
})();

// Accessibility labels for third-party widgets that are injected after page load.
(function () {
  var accessibilityFixQueued = false;

  function setButtonName(button, label) {
    if (!button) return;
    if (!button.getAttribute('aria-label') && !button.getAttribute('title') && !button.textContent.trim()) {
      button.setAttribute('aria-label', label);
    }
  }

  function setImportantStyle(element, property, value) {
    if (!element || !element.style) return;
    element.style.setProperty(property, value, 'important');
  }

  function applyExternalAccessibilityFixes() {
    var previewFrame = document.getElementById('PBarNextFrame');
    if (previewFrame && !previewFrame.getAttribute('title')) {
      previewFrame.setAttribute('title', 'Shopify preview bar');
    }

    document.querySelectorAll('button.chat-toggle').forEach(function (button) {
      setButtonName(button, 'Chat öffnen');
    });

    document.querySelectorAll('inbox-online-store-chat').forEach(function (widget) {
      if (!widget.shadowRoot) return;

      setButtonName(widget.shadowRoot.querySelector('button.chat-toggle'), 'Chat öffnen');
    });

    // Vision AI "similar products" thumbnails are injected without an accessible
    // name (the app sets the image alt asynchronously). Give each link a name.
    document.querySelectorAll('a.xsvai-item__thumbnail').forEach(function (link) {
      if (link.getAttribute('aria-label')) return;

      var name = '';
      var img = link.querySelector('img');
      if (img && img.getAttribute('alt')) {
        name = img.getAttribute('alt').trim();
      }
      if (!name) {
        var item = link.closest('.xsvai-item');
        var titleEl = item && item.querySelector('[class*="title"], [class*="name"]');
        if (titleEl) name = titleEl.textContent.trim();
      }

      link.setAttribute('aria-label', name || 'Produkt ansehen');
    });
  }

  function queueExternalAccessibilityFixes() {
    if (accessibilityFixQueued) return;
    accessibilityFixQueued = true;

    window.setTimeout(function () {
      accessibilityFixQueued = false;
      applyExternalAccessibilityFixes();
    }, 100);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyExternalAccessibilityFixes);
  } else {
    applyExternalAccessibilityFixes();
  }

  window.addEventListener('load', applyExternalAccessibilityFixes);

  new MutationObserver(queueExternalAccessibilityFixes).observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();

// =================================================================
// Scroll-/Positions-Wiederherstellung fuer Collections & Suche mit
// "Mehr laden" (Ajaxinate).
//
// Ziel: Klickt man in einer Kollektion auf ein Produkt und kehrt
// danach zurueck, landet man wieder an exakt der Stelle (inkl. der
// bereits nachgeladenen Produkte), an der man das Produkt angeklickt hat.
//
// Funktionsweise:
//  1. Beim Verlassen der Seite (pagehide) werden Scrollposition und die
//     Anzahl aktuell geladener Produkte (pro Collection-URL) gespeichert.
//  2. Nur bei echter Zurueck-Navigation werden so oft "Mehr laden" ausgeloest,
//     bis wieder gleich viele Produkte da sind, danach wird zur Scrollposition
//     gesprungen. Ajaxinate laedt synchron, deshalb genuegt eine einfache Schleife.
//     Ein Capture-Guard verhindert, dass der Link je echt navigiert.
// =================================================================
(function () {
  var GRID = '.collection__infinite-container, .search__infinite-container';
  var TRIGGER = '.collection__infinite-trigger, .search__infinite-trigger';
  var ITEM = '.product-item';

  function getGrid() { return document.querySelector(GRID); }
  function itemCount() {
    var grid = getGrid();
    return grid ? grid.querySelectorAll(ITEM).length : 0;
  }
  function stateKey() {
    return 'fs-collpos:' + window.location.pathname + window.location.search;
  }

  // Nur bei echter Zurueck-/Vorwaerts-Navigation wiederherstellen,
  // NICHT wenn die Kollektion frisch (z. B. ueber das Menue) geoeffnet wird.
  function isBackForward() {
    try {
      var nav = performance.getEntriesByType('navigation')[0];
      if (nav && nav.type) return nav.type === 'back_forward';
    } catch (e) {}
    try {
      if (performance.navigation) return performance.navigation.type === 2;
    } catch (e) {}
    return false;
  }

  // Hinweis: history.scrollRestoration = 'manual' und das Ausblenden des Inhalts
  // (Klasse 'fs-pos-restoring') passieren bereits im Inline-Script im <head>,
  // damit kein Aufblitzen entsteht. Hier wird nur wiederhergestellt und wieder eingeblendet.

  function revealPage() {
    document.documentElement.classList.remove('fs-pos-restoring');
  }

  // --- 1. Zustand beim Verlassen der Seite speichern ---
  // pagehide deckt jede Art des Verlassens ab (Produktklick, Menue, etc.).
  window.addEventListener('pagehide', function (e) {
    if (e.persisted) return; // geht in den bfcache -> kommt 1:1 zurueck, kein Speichern noetig
    if (!getGrid()) return;
    try {
      sessionStorage.setItem(stateKey(), JSON.stringify({
        scrollY: window.scrollY || window.pageYOffset || 0,
        count: itemCount()
      }));
    } catch (err) {}
  });

  // Loest einmal "Mehr laden" aus, ohne dass der Link je navigiert.
  // Gibt true zurueck, wenn Produkte dazugekommen sind.
  function loadMoreOnce() {
    var trigger = document.querySelector(TRIGGER);
    var link = trigger && trigger.querySelector('a[href]');
    if (!link) return false;

    var guard = function (ev) { ev.preventDefault(); }; // verhindert echte Navigation
    link.addEventListener('click', guard, true);
    var before = itemCount();
    link.click(); // Ajaxinate laedt synchron und haengt Produkte an
    link.removeEventListener('click', guard, true);

    return itemCount() > before;
  }

  // --- 2. Zustand bei Rueckkehr wiederherstellen ---
  function restorePosition() {
    if (!getGrid()) return;
    if (!isBackForward()) return;

    var raw;
    try { raw = sessionStorage.getItem(stateKey()); } catch (err) { return; }
    if (!raw) return;
    try { sessionStorage.removeItem(stateKey()); } catch (err) {}

    var state;
    try { state = JSON.parse(raw); } catch (err) { return; }
    if (!state) return;

    var target = state.count || 0;
    var safety = 0;
    while (itemCount() < target && safety < 50) {
      safety++;
      if (!loadMoreOnce()) break;
    }

    var y = state.scrollY || 0;
    // Zwei Versuche: sofort und nach dem naechsten Frame (Bilder/Layout),
    // damit die Zielposition auch bei spaetem Layout-Shift stimmt.
    window.scrollTo(0, y);
    window.requestAnimationFrame(function () { window.scrollTo(0, y); });
  }

  window.addEventListener('pageshow', function (e) {
    // bfcache: Seite inkl. Produkte & Scrollposition ist bereits 1:1 wieder da.
    if (e.persisted) { revealPage(); return; }
    // kurz warten, bis die Collection-Komponente (Ajaxinate) initialisiert ist,
    // danach wiederherstellen und Inhalt wieder einblenden.
    window.setTimeout(function () {
      try { restorePosition(); } finally { revealPage(); }
    }, 60);
  });
})();

// FS: Sticky-Filterleiste blendet beim Runterscrollen weg und kommt bei Bedarf zurueck.
// Reiner Klassen-Toggle (fs-filter-collapsed) an <form data-filter-bar> (ab 720px) bzw.
// .mobile-filters (darunter); kein DOM-Umbau der Leiste, ueberlebt daher das AJAX-Filtern
// (eine neu gerenderte Leiste startet immer sichtbar). Die Optik steht in
// custom-ithelps-frauenschuh.css (translate + opacity, Zeiten wie die Kopfzeile).
(function () {
  try {
    var CLS = 'fs-filter-collapsed';
    var DELTA = 6;        // Mindest-Scrolldistanz je Richtung
    var MOVE = 3;         // Mindest-Mausbewegung (Chrome feuert nach dem Scrollen Schein-mousemoves)
    var mqDesk = window.matchMedia('(min-width: 720px)');
    var lastY = window.pageYOffset || 0;
    var ticking = false;
    var lastMouse = null;
    var mouseTicking = false;
    var lastTop = null;

    function current() {
      return mqDesk.matches
        ? document.querySelector('form.filter-bar--sticky[data-filter-bar]')
        : document.querySelector('.mobile-filters--sticky[data-mobile-filters]');
    }
    function clearOthers(el) {
      var all = document.querySelectorAll('form.filter-bar--sticky[data-filter-bar], .mobile-filters--sticky[data-mobile-filters]');
      for (var i = 0; i < all.length; i++) {
        if (all[i] !== el) all[i].classList.remove(CLS);
      }
    }

    // Unterkante der klebenden Kopfzeile = Klebeposition der Leiste. Gemessen wird nur, solange die
    // Kopfzeile klebt (.is-sticky): davor hat sie noch ihre Ruhehoehe. Die Theme-Formel
    // (--height-header + --header-desktop-sticky-position) trifft die Kante hier nicht.
    function stickTop() {
      var hd = document.querySelector('.shopify-section.header__outer-wrapper header');
      if (hd && hd.classList.contains('is-sticky')) {
        var v = Math.max(0, Math.round(hd.getBoundingClientRect().bottom) - 1);
        if (v !== lastTop) {
          lastTop = v;
          document.documentElement.style.setProperty('--fs-fb-top', v + 'px');
        }
      }
      return lastTop === null ? 0 : lastTop;
    }

    // Marke direkt vor der Leiste: ihre Position = natuerlicher Platz der Leiste
    // (die Leiste selbst klebt bzw. ist verschoben und taugt nicht zur Messung)
    function sentinel(el) {
      var s = el.previousElementSibling;
      if (!s || !s.classList.contains('fs-fb-sentinel')) {
        s = document.createElement('span');
        s.className = 'fs-fb-sentinel';
        s.setAttribute('aria-hidden', 'true');
        el.parentNode.insertBefore(s, el);
      }
      return s;
    }

    function hasActiveFilter(el) {
      return el.classList.contains('filters-active') ||
        !!el.querySelector('.mobile-filters__button-count');
    }

    // Dropdown offen (Sortierung, Farbe/Groesse/Material) oder Filter-Panel von Hand aufgeklappt
    // oder Tastaturfokus in der Leiste -> nicht wegblenden
    function blocked(el) {
      if (el.classList.contains('filter-bar--wash-active')) return true;
      if (el.querySelector('.filter-group__values[aria-hidden="false"]')) return true;
      if (!el.classList.contains('filters-active') &&
          el.querySelector('[data-dropdown-toggle="filter-bar-filters"][aria-expanded="true"]')) return true;
      var f = document.activeElement;
      if (f && f !== document.body && el.contains(f)) {
        try { if (f.matches(':focus-visible')) return true; } catch (e) { return true; }
      }
      return false;
    }

    function measureShift(el) {
      var c = el.querySelector('.filter-bar__collapsible');
      var a = el.querySelector('.filter-bar__active-filters');
      if (!c || !a) return;
      el.style.setProperty('--fs-fb-shift', Math.max(0, a.offsetTop - c.offsetTop) + 'px');
    }

    function set(el, collapsed) {
      if (collapsed) measureShift(el);
      if (el.classList.contains(CLS) === collapsed) return;
      el.classList.toggle(CLS, collapsed);
    }

    function update() {
      ticking = false;
      var el = current();
      if (!el || !el.parentNode) return;
      clearOthers(el);
      var y = window.pageYOffset || document.documentElement.scrollTop || 0;
      var top = stickTop();
      var stuck = sentinel(el).getBoundingClientRect().top <= top + 1;

      // mobil ohne Chips-Zeile: bei aktivem Filter stehen lassen (Zaehler am Button bleibt sichtbar)
      if (!stuck || blocked(el) || (!mqDesk.matches && hasActiveFilter(el))) {
        set(el, false);
        lastY = y;
        return;
      }
      if (y > lastY + DELTA) {
        set(el, true);
      } else if (y < lastY - DELTA) {
        set(el, false);
      } else {
        if (el.classList.contains(CLS)) measureShift(el);
        return; // kleine Bewegung: lastY nicht nachziehen
      }
      lastY = y;
    }

    function requestUpdate() {
      if (!ticking) { ticking = true; window.requestAnimationFrame(update); }
    }
    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate, { passive: true });

    // Desktop: Maus faehrt in den Bereich, wo die Leiste war (oberer Rand des Produktbereichs)
    document.addEventListener('mousemove', function (e) {
      var moved = !lastMouse || Math.abs(e.clientX - lastMouse.x) >= MOVE || Math.abs(e.clientY - lastMouse.y) >= MOVE;
      if (!moved) return;
      lastMouse = { x: e.clientX, y: e.clientY };
      if (mouseTicking || !mqDesk.matches) return;
      mouseTicking = true;
      window.requestAnimationFrame(function () {
        mouseTicking = false;
        var el = current();
        if (!el || !el.classList.contains(CLS)) return;
        var top = stickTop();
        var inZone = lastMouse.y >= top && lastMouse.y <= top + el.offsetHeight;
        if (inZone) {
          set(el, false);
          lastY = window.pageYOffset || 0;
        }
      });
    }, { passive: true });

    // Tastatur: Fokus in der Leiste -> sofort sichtbar
    document.addEventListener('focusin', function (e) {
      var el = current();
      if (el && el.classList.contains(CLS) && el.contains(e.target)) {
        set(el, false);
        lastY = window.pageYOffset || 0;
      }
    });

    // Kopfzeilenhoehe kann sich aendern (Schrift, Umbruch): Klebeposition nachziehen
    if (window.ResizeObserver) {
      var hw = document.querySelector('.shopify-section.header__outer-wrapper header');
      if (hw) new ResizeObserver(requestUpdate).observe(hw);
    }
    requestUpdate();
  } catch (err) { /* Filterleisten-Collapse ist rein kosmetisch */ }
})();
